export enum Role {
  FullAdmin = 'NBI_FULL_ADMIN',
  RestrictedAdmin = 'NBI_RESTRICTED_ADMIN',
  User = 'NBI_USER',
  DECC = 'DECC_USER',
  RSP = 'RSP_USER',
  IndependentAuditor = 'INDEPENDENT_AUDITOR',
}
